import { render } from "./ParameterItemElement.vue?vue&type=template&id=368e9df9&ts=true"
import script from "./ParameterItemElement.vue?vue&type=script&lang=ts"
export * from "./ParameterItemElement.vue?vue&type=script&lang=ts"

import "./ParameterItemElement.vue?vue&type=style&index=0&id=368e9df9&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
